import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BaseComponent} from './component/base-component';
import {BaseFormComponent} from './component/base-form-component';
import {CanDeactivateGuard} from './can-deactivate-guard';
import {CanDeactivateFormComponent} from './component/can-deactivate-form-component';
import {CanDeactivateComponent} from './component/can-deactivate-component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    BaseComponent, BaseFormComponent, CanDeactivateComponent, CanDeactivateFormComponent,
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    TranslateModule
  ],
  providers: [CanDeactivateGuard],
  exports: [BaseComponent, BaseFormComponent, CanDeactivateFormComponent]
})
export class NcSharedModule {
}
